export function weight(a, b) {
  return b.value - a.value;
}
export function frequency(a, b) {
  return b.frequency - a.frequency;
}
export function id(a, b) {
  return "".concat(a.id).localeCompare("".concat(b.id));
}
export function name(a, b) {
  return "".concat(a.name).localeCompare("".concat(b.name));
}